import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=56bc74db&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=56bc74db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bc74db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56bc74db')) {
      api.createRecord('56bc74db', component.options)
    } else {
      api.reload('56bc74db', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=56bc74db&scoped=true&", function () {
      api.rerender('56bc74db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PtMITDlJ8ZSM/JS/comp/PopupDialog.vue"
export default component.exports